import React, { Component } from 'react';
import {Spin} from 'antd'
import GetUrlParam from '../components/getUrlParam'
import  './success_login.less'
import Axios from '../components/request/axios'
import QRCode  from 'qrcode.react';
import Base64 from "../components/base64";
import getIdFromUrl from "../components/getIdFromUrl";
class SuccessLogin extends Component {
    state={
        spinning:true,
        resCode:0,
        qrUrlX:'https://api.ticks.precisiongenes.com.cn/parent', ///默认家长端的
        small_program_name:'抽动 小贴士',
        userTypeSpan:'家长'
    };
    componentDidMount() {
        let  userType=GetUrlParam('userType');///获取用户以什么身份扫的码
        console.log(userType);
        if(userType==='doctor'){
            this.setState({
                qrUrlX:'https://api.ticks.precisiongenes.com.cn/'+userType,
                small_program_name:'抽动障碍协作组',
                userTypeSpan:'医生'
            });
        }
        //获取url参数信息
        let code=GetUrlParam('code');
        //let state=GetUrlParam('state');
        // 传输obj给 src\common\WXLogin\index.jsx 的 message监听事件
        /*let obj={
            code,state
        };*/
        //console.log(obj);
        let _this=this;
        Axios.post('/api/v1/wechat-scan-login/',{code:code}).then((res)=>{
          if(res){
              console.log(res);
              if(res.code===20001){///用户未在小程序注册
                  _this.setState({
                      spinning:false,
                      resCode:res.code
                  });
              }
              if(res.code===20002){///用户注册了，判断用户是有医生端账号还是家长端账号，如果对应不上，设置code为20001
                 let data=res.data;
                 let hasAccount=false;///默认没有匹配的账号
                 for(let i=0;i<data.length;i++) {
                     let username = data[i].username;//用户姓名
                     if(username.match(userType)){///如果匹配，用户正常登录页面
                         hasAccount=true;///匹配到账号了,改为true
                         ///todo:医生端，但是医生身份未审核，提示用户
                         if(userType==='doctor'&&Number(getIdFromUrl(data[i].grade_name))>2){
                             _this.setState({
                                 resCode:20003,
                                 spinning:false,
                             });
                             break;
                         }
                         let values={
                             username:data[i].username,
                             password:data[i].wechat_union_id
                         };
                         _this.setState({
                             resCode:20002
                         });
                         Axios.post('/api/v1/token-auth/',values).then((response) => {
                             if (response){
                                 let token=response.token;
                                 let nowTimeStamp=(new Date()).valueOf();
                                 window.localStorage.setItem('token',token+"&&"+nowTimeStamp);
                                 let token1=token.split(".");
                                 let info=Base64.decode(token1[1]);//获取token里的部分用户信息
                                 let userId=info.split(',')[0].split(':')[1];//用户id
                                 window.sessionStorage.setItem("current","index_#/");///默认为首页
                                 Axios.get('/api/v1/users/'+userId+'/').then((res)=>{
                                     //console.log(res);
                                     window.localStorage.setItem('userInfo',JSON.stringify(res));
                                     setTimeout(()=>{///延迟清除websocket
                                         window.client.disconnect(function() {
                                             console.log('清除成功！');
                                         });
                                     },2000);
                                     window.parent.location.hash='#/';
                                 });
                             }else {
                                 _this.setState({
                                     loading: false
                                 });
                             }
                         });
                         break;
                     }

                 }
                 if(!hasAccount){///没有匹配到账号
                     _this.setState({
                         spinning:false,
                         resCode:20001
                     })
                 }
              }
          }
        });
        //window.parent.location.hash='#/'
    }
    render() {
        let {resCode,small_program_name,userTypeSpan}=this.state;
        return <div className='success_content'>
            <Spin tip={'验证登录中...'} spinning={this.state.spinning}>

            </Spin>
            {
                this.state.spinning?'':
                    <div>
                        {resCode===20003?<div>
                            <div style={{padding:'65px 0'}}>医生账号未审核，请联系管理员</div>
                        </div>:''
                        }
                        {resCode===20002?<div>
                            <span>登录成功</span>
                        </div>:''
                        }
                        {resCode===20001?
                            <div>
                                <span style={{color:'#666',display:'block',textAlign:'left'}}>1、您如果没有{userTypeSpan}账号，请扫描下方二维码注册账号</span>
                                <span style={{color:'#666',display:'block',textAlign:'left'}}>2、点击个人中心授权登录</span>
                                <span style={{color:'#666',display:'block',textAlign:'left'}}>3、注册完成需刷新此页面重新获取登录码</span>
                                <div style={{paddingTop:'30px'}}>
                                    <QRCode
                                        value={this.state.qrUrlX}  //value参数为生成二维码的链接
                                        size={230} //二维码的宽高尺寸
                                        fgColor="#000000"  //二维码的颜色
                                    />
                                    <div style={{fontWeight:'bold',color:'lightsalmon'}}>{small_program_name}</div>
                                </div>
                            </div>:''
                        }
                    </div>
            }
        </div>;
    }
}
export default SuccessLogin